import React from "react";
import ListIncidents from "./ListIncidents/ListIncidents.component";

const Incidents = () => <ListIncidents />;

export default Incidents;
